module.exports = __webpack_public_path__ + "static/stardust-card-large-958652c3a7a2697e90364d70cbf1cd83.png";